import { Button, Flex, Heading, Popover, Text } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface FilterButtonMenuHeaderProps {
  title: string;
  onClearAll?: () => void;
}

export const FilterButtonMenuHeader: React.FC<FilterButtonMenuHeaderProps> = ({
  title,
  onClearAll,
}) => {
  const { t } = useTranslation();

  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
      px={3}
      py={2}
      borderBottomWidth="1px"
      borderColor="cardBorder"
    >
      <Heading size="sm" fontWeight="semibold" color="primary.900">
        {title}
      </Heading>
      {onClearAll && (
        <Popover.CloseTrigger asChild>
          <Button
            aria-label={t('common.clearAll')}
            variant="ghost"
            size="xs"
            h="28px"
            px={2}
            onClick={onClearAll}
            colorPalette="primary"
            color="primary.900"
            _hover={{ bg: 'primary.50' }}
          >
            <Text fontSize="xs" fontWeight="semibold">
              {t('common.clearAll')}
            </Text>
          </Button>
        </Popover.CloseTrigger>
      )}
    </Flex>
  );
};
